module.exports = __webpack_public_path__ + "static/media/wheel-light@2x.463a8ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/wheel-light@2x.png
// module id = 1119
// module chunks = 0